import { GameState } from '../game/GameState';

/**
 * UI component for displaying loaf health information
 */
export class LoafUI {
  private element: HTMLElement;
  private gameState: GameState;
  private lastLoafHealth: number = 0;
  
  constructor() {
    this.gameState = GameState.getInstance();
    
    console.log('LoafUI: Initializing UI component');
    
    // Create UI element
    this.element = this.createUIElement();
    
    // Add to DOM
    document.body.appendChild(this.element);
    
    console.log('LoafUI: Element created and added to DOM');
  }
  
  /**
   * Create the UI element
   */
  private createUIElement(): HTMLElement {
    const element = document.createElement('div');
    
    // Set ID for potential styling
    element.id = 'loaf-ui';
    
    // Style the container
    element.style.position = 'absolute';
    element.style.top = '10px';
    element.style.left = '10px';
    element.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    element.style.color = 'white';
    element.style.padding = '10px 15px';
    element.style.borderRadius = '5px';
    element.style.fontFamily = 'Arial, sans-serif';
    element.style.fontSize = '18px';
    element.style.fontWeight = 'bold';
    element.style.textAlign = 'left';
    element.style.zIndex = '1000';
    
    // Initial content
    element.innerHTML = '🍞 0';
    
    return element;
  }
  
  /**
   * Update the UI
   */
  public update(): void {
    // Get current loaf health
    const loafHealth = this.gameState.getLoafHealth();
    
    // Only update DOM if values have changed
    if (this.lastLoafHealth !== loafHealth) {
      // Update the element with health and color based on remaining health
      this.element.innerHTML = `🍞 ${loafHealth}`;
      
      // Update color based on health percentage
      const maxHealth = 40; // From config
      const healthPercent = loafHealth / maxHealth;
      
      if (healthPercent <= 0.25) {
        // Critical - red
        this.element.style.color = '#FF4444';
      } else if (healthPercent <= 0.5) {
        // Warning - orange
        this.element.style.color = '#FFAA22';
      } else {
        // Healthy - white
        this.element.style.color = 'white';
      }
      
      // Store values to avoid unnecessary DOM updates
      this.lastLoafHealth = loafHealth;
    }
  }
} 